export default function About() {
  return (
    <table height="452" border="0" align="center">
      <tr>
        <td width="400" height="154" valign="top">
          <table border="0">
            <tr>
              <td>
                <img
                  id="png"
                  src="/assets/silfo-1.png"
                  width="120"
                  height="120"
                />
              </td>
            </tr>
            <tr>
              <td>name: silfo </td>
            </tr>
            <tr>
              <td>ocupation: world savior </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <td height="154" valign="top">
          <table border="0">
            <tr>
              <td>
                <img
                  id="png"
                  src="/assets/adgam-1.png"
                  width="120"
                  height="120"
                />
              </td>
            </tr>
            <tr>
              <td>name: adgam </td>
            </tr>
            <tr>
              <td>ocupation: world savior </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <td align="center" valign="bottom">
          <b>Guestbook: </b>
          <a class="1" href="?guestbook">
            sign here
          </a>
          <br />
          <br />
          <b>Credits:</b>
          <br />
          Guestbook (Tagboard) from{' '}
          <a
            class="1"
            href="http://www.cj-design.com/"
            target="_blank"
            rel="noreferrer"
          >
            CJ-Website Design
          </a>
          <br />
          News script (CuteNews) from{' '}
          <a
            class="1"
            href="http://www.cutephp.com/"
            target="_blank"
            rel="noreferrer"
          >
            CutePHP.com
          </a>{' '}
        </td>
      </tr>
    </table>
  );
}
